import API from "api/API";
import useFetchData from "hooks/useFetchData";

export default function useEditions() {
   const { d: rawData, ...rest } = useFetchData({
      APIMethod: API.getEditions,
      cache_name: "editions",
      resultDataHandler: data => data.map( e => ({
         value: e.name,
         label: e.name,
         id: e.id,
         raw_data_file_url: e.raw_data_file_url
      }))
   });
   
   return {
      d: rawData,
      ...rest
   };
}